(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-medication', {
            parent: 'entity',
            url: '/prog-medication',
            data: {
                authorities: [],
                pageTitle: 'ProgMedications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-medication/prog-medications.html',
                    controller: 'ProgMedicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access);
            }]
        })
        .state('prog-medication.new', {
            parent: 'prog-medication',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-dialog.html',
                        controller: 'ProgMedicationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('prog-medication');
                    });
                }
            }]
        })
        .state('prog-medication.edit', {
            parent: 'prog-medication',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-dialog.html',
                        controller: 'ProgMedicationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['ProgMedication', function (ProgMedication) {
                                return ProgMedication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-medication.delete', {
            parent: 'prog-medication',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-delete-dialog.html',
                        controller: 'ProgMedicationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['ProgMedication', function (ProgMedication) {
                                return ProgMedication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();
